"use client";

import classNames from "classnames";
import React, { useState } from "react";

type CollapsibleProps = {
  children: React.ReactNode;
  // Elements marked with data-collapsible-extra are hidden until expanded.
  hasMore: boolean;
};

const Collapsible = ({ children, hasMore }: CollapsibleProps) => {
  const [expanded, setExpanded] = useState(false);

  return (
    <>
      <div
        className={classNames(
          "[&>*:first-child]:mt-0 [&>*:last-child]:mb-0",
          { "[&_[data-collapsible-extra]]:hidden": hasMore && !expanded },
        )}
      >
        {children}
      </div>
      {hasMore && (
        <div className="relative">
          {!expanded && (
            <div className="absolute bottom-full left-0 right-0 h-16 bg-gradient-to-t from-sand-600 to-transparent pointer-events-none" />
          )}
          <button
            onClick={() => setExpanded((prev) => !prev)}
            aria-expanded={expanded}
            className="btn btn-secondary bg-sand-700 block mx-auto mt-4"
          >
            {expanded ? "Visa mindre" : "Visa mer"}
          </button>
        </div>
      )}
    </>
  );
};

export default Collapsible;
